import { Injectable } from '@angular/core';

import { Observable, of, shareReplay, startWith } from 'rxjs';

import { INotification } from '../../modules/acca-boost/model';
import { AccaBoostNotificationService } from '../../modules/acca-boost/services/acca-boost-notification.service';

@Injectable()
export class BetslipReturnsMessagesAccaBoostService {
    readonly accaBoostNotifications$: Observable<INotification | null>;

    constructor(accaBoostNotificationService: AccaBoostNotificationService) {
        this.accaBoostNotifications$ = accaBoostNotificationService.areNotificationsEnabled()
            ? accaBoostNotificationService.getNotifications$().pipe(startWith(null), shareReplay())
            : of(null);
    }
}
